export class DeleteDevOpsActionResponse {
    eventRuleId?: string;
    error?: string;
}